import * as React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { Date, DateField, AutoComplete, AutoCompleteField, Input, InputField } from '@components/form';

import * as T from '@modules/employees/_employeesTypes';
import { identificationTypeEnum } from '@modules/employees/_employeesEnums';

const enhance = compose<T.EmplyeesFormProps, T.Outter & T.EmplyeesFormProps>(
  reduxForm({
    form: 'module-employee-contracts'
  })
);

const View: React.SFC<T.Outter & T.EmplyeesFormProps> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Typ dokladu</h4>
              </Col>
              <Col md={8}>
                <AutoCompleteField
                  component={AutoComplete}
                  name="type"
                  items={identificationTypeEnum}
                  fullWidth={true}
                  labelFunction={o => get(o, 'label')}
                  valueFunction={o => get(o, 'id')}
                  arrowstyle={{
                    color: '#e1e0e1',
                    position: 'absolute',
                    right: 0,
                    top: 16
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Datum vydání</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} name="issuedOn" />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Platnost do</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} name="validTo" allowFuture={true} />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Číslo dokladu</h4>
              </Col>
              <Col md={8}>
                <InputField component={Input} name="value" />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EmployeesFormIdentificationsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormIdentificationsForm.tsx